import { DRIVER_STATUS_FILTERS } from "../../Reports/DriverPerformance/components/Filters/constants";

const DISPATCH_MAP_FILTERS = {
  pickupCompleted: "Completed Pickup",
  pickupAssigned: "Assigned",
  pickupUnassigned: "Unassigned",
  pickupPriority: "pickupPriority",
  pickupPending: "Pending Pickup",
  deliveryCompleted: "Completed Delivery",
  deliveryPending: "Pending Delivery",
  deliveryReturned: "Returned Delivery",
  deliveryPriority: "deliveryPriority",
  spottedTrailers: "spottedTrailers",
}

const PICKUP_STATUS = {
  allPickups: "All",
  assigned: "Assigned",
  unassigned: "Unassigned",
  future: "Future",
  missed: "Missed",
  completed: "Completed",
  noFreight: "NoFreight",
  voided: "Voided",
  dailyPickup: "DailyPickup",
  newPickup: "NewPickup",
  unacknowledged: "UnAcknowledged",
  notCompleted: "NotCompleted",
  toBeReviewed: "ToBeReviewed",
};

const DEFAULT_DISPATCH_MAP_FILTERS = [
  DISPATCH_MAP_FILTERS.deliveryPending,
  DISPATCH_MAP_FILTERS.pickupPending,
];

const HZ_FILTER = [
  { value: "HZ", text: "Hazard", icon: "icon-hazmat", tooltip: "Hazmat" },
  { value: "", text: "(BLANKS)" },
];
const DRIVER_STATUS = {
  "Completed Pickup": "Picked up",
  "Pending Pickup": "Pickup Pending",
  "Completed Delivery": "Delivered",
  "Pending Delivery": "Delivery Pending",
  "Returned Delivery": "Delivery Returned",
};
const DRIVER_EVENTS = {
  ArrivedAtStop: "ArrivedAtStop",
  EnrouteToStop: "EnrouteToStop",
  ReturnToTerminal: "ReturnToTerminal",
  DelayStart: "DelayStart",
  LunchBreak: "LunchBreak",
  FuelBreak: "FuelBreak",
  RestBreak: "RestBreak",
};
const SHOW_DRIVER_EVENTS = {
  ArrivedAtStop: "Arrived at ",
  EnrouteToStop: "Enroute To ",
  DelayStart: "Delay Start",
  NextEnrouteTo: "Next enroute to",
};
const SHOW_DRIVER_LOGGED_STATUS = {
  loggedIn: "Logged In",
  loggedOut: "Logged Out",
};

const DRIVER_CLOCKED_IN_STATUS = "Driver not clocked-in";

const DRIVER_VISIBLE_TIME = 60; // in minutes

const DRIVER_LOGGED_STATUS = {
  loggedIn: "loggedIn",
  loggedOut: "loggedOut",
};

const LIMITED_ACCESS_PICKUP = "LIMITP";

const ALL_DRIVER_STATUS = {
  ...DRIVER_STATUS_FILTERS,
  LateBy: "LateBy",
  DueTime: "DueTime",
  Dispatched: "Dispatched",
  DriverClockedIn: "DRIVER_CLOCKED_IN",
  DriverClockedOut: "DRIVER_CLOCKED_OUT",
  StopsCompleted: "StopsCompleted",
  UndoArriveAtStop: "UndoArriveAtStop",
  DispatchDeliveryCompleted: "DispatchDeliveryCompleted",
  NextStopChanged: "NextStopChanged",
  Bobtail: "Bobtail",
  BillsMoved: "BillsMoved",
  DispatchNoFreightPickedup: "DispatchNoFreightPickedup",
  ActiveRouteChanged: "ActiveRouteChanged",
  LeaveTerminal: "LeaveTerminal",
  EnterTerminal: "EnterTerminal",
  NoFreightPickedUp: "NoFreightPickedUp",
  PickupCompleted: "PickupCompleted",
  DispatchPickupCompleted: "DispatchPickupCompleted",
};
const DELIVERY_ACCESSORIALS = {
  LIMITED_ACCESS: "LIMIT",
  LIFTGATE: "LGATE",
  RESIDENTIAL: "RESDEL",
  INSIDE_DELIVERY: "ISD",
  SORT_AND_SEGREGATE: "SORT",
};
const PICKUP_ACCESSORIALS = {
  LIFTGATE: "LGATEP",
  MARKKING_OR_TAGGING: "MARKO",
  LIMITED_ACCESS: "LIMITP",
  RESIDENTIAL: "RESPU",
  INSIDE_PICKUP: "ISPU",
  SORT_AND_SEGREGATE: "SORT",
};

const COUNTRIES = { US: "US", CN: "CN", MX: "MX" };
const COUNTRY_LIST = [
  {code: 'US', name: 'US'},
  {code: 'CN', name: 'Canada'},
  {code: 'MX', name: 'Mexico'},
];

const CITY_VALUE_PARAMS = {
  placeholder: "Add City",
  format: /^.{0,20}$/, // Use for validating new city length
};
const CONSIGNEE_NAME_VALUE_PARAMS = {
  placeholder: "Add Consignee Name",
  format: /^.{0,30}$/, // Use for validating new consigneeName length
};

const HOOK_TYPE_OPTION = {
  Trailer: "Trailer",
  Bobtail: "Bobtail",
};

const DROP_TRAILER_TYPE = {
  CustomerDelivery : "CustomerDelivery",
  EmptyTrailer: "EmptyTrailer",
  TemporaryLocation: "TemporaryLocation",
  AgentInterline: "AgentInterline",
};

const DROP_TRAILER_OPTIONS = [
  {
    label: "Customer Delivery",
    value: DROP_TRAILER_TYPE.CustomerDelivery,
  },
  { label: "Empty Trailer", value: DROP_TRAILER_TYPE.EmptyTrailer },
  {
    label: "Temporary Location",
    value: DROP_TRAILER_TYPE.TemporaryLocation,
  },
  {
    label: "Agent or Interline",
    value: DROP_TRAILER_TYPE.AgentInterline,
  },
];

const Drop_Hook_Move_Page_Names = {
  DROP_HOOK_MOVE: "Drop-Hook-Move",
  TRAILER_DROP: "Trailer Drop",
  MOVE_BILLS: "Move Bills",
};

const STOP_TYPES = {
  TERMINAL: "Terminal",
  DELIVERY: "Delivery",
  PICKUP: "Pickup",
  LUNCHBREAK: "LunchBreak",
};

const PICKUP_NUMBER_TIME_CONSTRAINT = {
  Min: 0,
  Max: 11,
};

export {
  DISPATCH_MAP_FILTERS,
  PICKUP_STATUS,
  DEFAULT_DISPATCH_MAP_FILTERS,
  HZ_FILTER,
  DRIVER_STATUS,
  DRIVER_EVENTS,
  SHOW_DRIVER_EVENTS,
  SHOW_DRIVER_LOGGED_STATUS,
  DRIVER_LOGGED_STATUS,
  DRIVER_CLOCKED_IN_STATUS,
  DRIVER_VISIBLE_TIME,
  ALL_DRIVER_STATUS,
  DELIVERY_ACCESSORIALS,
  PICKUP_ACCESSORIALS,
  LIMITED_ACCESS_PICKUP,
  COUNTRIES,
  COUNTRY_LIST,
  CITY_VALUE_PARAMS,
  CONSIGNEE_NAME_VALUE_PARAMS,
  HOOK_TYPE_OPTION,
  DROP_TRAILER_OPTIONS,
  Drop_Hook_Move_Page_Names,
  STOP_TYPES,
  PICKUP_NUMBER_TIME_CONSTRAINT,
  DROP_TRAILER_TYPE
};
